import React, { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusPendingIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 33 33">
      <circle
        opacity="0.1"
        cx="16.5"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <g clipPath="url(#clip0_10836_99598)">
        <path
          d="M21.4492 8.30874V11.5156H24.6559L21.4492 8.30874Z"
          fill={theme.colors.lightgreen}
        />
        <path
          d="M20.9219 12.5703C20.6306 12.5703 20.3945 12.3342 20.3945 12.043V8H12.8359C11.9636 8 11.2539 8.7097 11.2539 9.58203V15.4773C11.4276 15.4616 11.6035 15.4531 11.7812 15.4531C13.5787 15.4531 15.1878 16.2749 16.2526 17.5625H21.9766C22.2678 17.5625 22.5039 17.7986 22.5039 18.0898C22.5039 18.3811 22.2678 18.6172 21.9766 18.6172H16.9474C17.277 19.2604 17.4896 19.973 17.5578 20.7266H21.9766C22.2678 20.7266 22.5039 20.9627 22.5039 21.2539C22.5039 21.5451 22.2678 21.7812 21.9766 21.7812H17.5578C17.4001 23.5229 16.4696 25.0447 15.1126 26H23.3828C24.2551 26 24.9648 25.2903 24.9648 24.418V12.5703H20.9219ZM21.9766 15.4531H14.2422C13.951 15.4531 13.7148 15.217 13.7148 14.9258C13.7148 14.6345 13.951 14.3984 14.2422 14.3984H21.9766C22.2678 14.3984 22.5039 14.6345 22.5039 14.9258C22.5039 15.217 22.2678 15.4531 21.9766 15.4531Z"
          fill={theme.colors.lightgreen}
        />
        <path
          d="M11.7812 16.5078C9.16425 16.5078 7.03516 18.6369 7.03516 21.2539C7.03516 23.8709 9.16425 26 11.7812 26C14.3982 26 16.5273 23.8709 16.5273 21.2539C16.5273 18.6369 14.3982 16.5078 11.7812 16.5078ZM13.1875 21.7812H11.7812C11.49 21.7812 11.2539 21.5451 11.2539 21.2539V19.1445C11.2539 18.8533 11.49 18.6172 11.7812 18.6172C12.0725 18.6172 12.3086 18.8533 12.3086 19.1445V20.7266H13.1875C13.4787 20.7266 13.7148 20.9627 13.7148 21.2539C13.7148 21.5451 13.4787 21.7812 13.1875 21.7812Z"
          fill={theme.colors.lightgreen}
        />
      </g>
      <defs>
        <clipPath id="clip0_10836_99598">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(7 8)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
